import { render, staticRenderFns } from "./PreviewNotaFiscalServicoView.vue?vue&type=template&id=06e97579&scoped=true"
import script from "./PreviewNotaFiscalServicoView.vue?vue&type=script&lang=js"
export * from "./PreviewNotaFiscalServicoView.vue?vue&type=script&lang=js"
import style0 from "./PreviewNotaFiscalServicoView.vue?vue&type=style&index=0&id=06e97579&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e97579",
  null
  
)

export default component.exports